// extracted by mini-css-extract-plugin
export default {"UDPFormRoot":"UDPFormRoot---Opocu","UDPFormContent":"UDPFormContent---_u4i6"};